// extracted by mini-css-extract-plugin
module.exports = {"root":"social-media-slider_root__OZjoO","marquee":"social-media-slider_marquee__f3SOf"};